export const SEARCH_DESTINATIONS = [
  { label: 'Dashboard', code: 'HOME', to: '/dashboard' },
  { label: 'Soteria AI', code: 'AI', to: '/soteria' },
  { label: 'Clients', code: 'CLIENTS', to: '/clients' },
  { label: 'Portfolios', code: 'PORT', to: '/portfolio' },
  { label: 'Execution', code: 'EXEC', to: '/execution' },
  { label: 'Meeting bots', code: 'MEET', to: '/meeting-bots' },
  { label: 'Strategies', code: 'STRAT', to: '/strategies' },
  { label: 'Settings', code: 'SET', to: '/settings' },
  { label: 'Integrations', code: 'CONNECT', to: '/integrations' },
  { label: 'Orders', code: 'ORD', to: '/execution', tab: 'orders' },
  { label: 'Trades', code: 'TRD', to: '/execution', tab: 'trades' },
  { label: 'Rebalancer', code: 'REBAL', to: '/execution', tab: 'rebalancer' },
  { label: 'Changes', code: 'CHANGES', to: '/execution', tab: 'changes' },
  { label: 'Connections', code: 'CONN', to: '/settings', tab: 'connections' },
  {
    label: 'Confirmations',
    code: 'CONF',
    to: '/execution',
    tab: 'confirmations',
  },
] as const;
export type SearchDestination = (typeof SEARCH_DESTINATIONS)[number];
/** Only implemented security functions are accepted as suffixes. */
export function securitySearchTerm(query: string) {
  return query
    .trim()
    .replace(/\s+(DES|QUOTE)$/i, '')
    .trim()
    .toUpperCase();
}
